<template>
  <div class="row">

    <div class="col-md-12">
      <create-budget-form @on-submit="onCreateModelSubmit"></create-budget-form>
    </div>
  </div>
</template>
<script>
  import CreateBudgetForm from './Forms/CreateBudgetForm.vue'

  export default {
    components: {
      CreateBudgetForm
    },
    data () {
      return {

        createBudgetModel: {}
      }
    },
    methods: {
      onCreateModelSubmit (model, isValid) {
        model.saveBudgetButtonText = 'Saving Budget ...'
        this.$http.put('/budgets/' + this.$route.params.id, {
            amount: model.amount * 100,
            category_id: model.category,
          })
          .then(response =>{
            if(response.data){
              model.saveBudgetButtonText = 'Budget Saved'
            }
          })
          .catch(error => {
            console.error(error);
          })
      }
    }
  }
</script>
<style>
</style>
